import { Icon, Text } from 'ui/components/primitives';
import { styled, theme } from 'ui/theme';

export const Tooltip = {
  Component: styled.span`
    display: inline-block;
    margin-left: ${theme.space[1]};
    position: relative;
    line-height: 0;

    &[data-pdp='true'] {
      margin-left: 0px;
    }
  `,

  Content: styled.span`
    border-radius: ${theme.radii.small};
    column-gap: ${theme.space[2]};
    display: flex;
    align-items: flex-start;
    padding: ${theme.space[4]};
    position: absolute;
    z-index: 1400;
    max-width: 272px;
    background-color: ${theme.colors.build.darkLight};
    color: ${theme.colors.build.lightDark2};

    &[data-direction='down'] {
      top: calc(100% + ${theme.space[1]});
    }

    &[data-direction='up'] {
      bottom: calc(100% + ${theme.space[1]});
    }

    &[data-align='left'] {
      left: 0;
    }

    &[data-align='center'] {
      left: 50%;
      transform: translateX(-50%);
    }

    &[data-align='right'] {
      right: 0;
    }

    &[data-pdp='true'] {
      background-color: ${theme.colors.build.lightLight};
      border: 1px solid ${theme.colors.build.brand2};
      color: ${theme.colors.build.darkDark};
      visibility: hidden;
    }
    &[data-pdp-visible='true'] {
      visibility: visible;
    }
  `,

  ContentText: styled(Text)`
    min-width: 150px;
  `,

  Icon: styled(Icon.Info)`
    flex: 0 0 ${theme.sizes[4]};
  `,

  Wrapper: styled.span`
    user-select: none;

    &:after {
      border-style: solid;
      color: ${theme.colors.build.darkLight};
      display: block;
      height: ${theme.sizes[0]};
      position: absolute;
      width: ${theme.sizes[0]};
      z-index: ${theme.zIndices.tooltip};
      left: 50%;
      transform: translateX(-50%);
    }

    &[data-pdp='true'] {
      &:after {
        color: ${theme.colors.build.brand2};
      }
    }

    &[data-pdp-visible='true'][data-pdp='true'] {
      &:after {
        content: '';
        color: ${theme.colors.build.brand2};
      }
      visibility: visible;
    }

    &[data-pdp-visible='true'][data-pdp='false'] {
      &:after {
        content: '';
        color: ${theme.colors.build.darkLight};
      }
      visibility: visible;
    }

    &[data-visibility='true'] {
      &:after {
        content: '';
      }
    }

    &[data-direction='down'] {
      &:after {
        border-color: transparent transparent currentColor transparent;
        border-width: ${theme.sizes[0]} ${theme.sizes[2]} ${theme.sizes[2]} ${theme.sizes[2]};
        bottom: calc(-1 * ${theme.space[2]});
      }
    }

    &[data-direction='up'] {
      &:after {
        border-color: currentColor transparent transparent transparent;
        border-width: ${theme.sizes[2]} ${theme.sizes[2]} 0 ${theme.sizes[2]};
        top: calc(-1 * ${theme.space[2]});
      }
    }
  `,
};
